module.exports = __webpack_public_path__ + "static/media/img28.aa8374dc.JPG";